import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuth } from '../contexts/AuthContext'
import { colors } from '../styles/theme'

export const NO_TEAM_PATH = '/app/no-team'

export default function ProtectedRoute() {
  const { user, loading } = useAuth()
  const { pathname } = useLocation()

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: colors.background,
        color: colors.textSecondary,
        fontSize: '14px',
      }}>
        Loading...
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Auditors have no team and no app access: only the read-only audit portal.
  if (user.isAuditor) {
    return <Navigate to="/audit" replace />
  }

  // An account on no team (it left its last one) can only create or join a team: every other page needs one, and its
  // requests would 401 straight back to /login.
  const onNoTeamPage = pathname.startsWith(NO_TEAM_PATH)
  if (!user.teamId && !onNoTeamPage) return <Navigate to={NO_TEAM_PATH} replace />
  if (user.teamId && onNoTeamPage) return <Navigate to="/app/dashboard" replace />

  return <Outlet />
}
